var map = {
	"./1.jpg": 421,
	"./10.jpg": 79291,
	"./26.jpg": 86876,
	"./WhatsApp Image 2022-10-13 at 4.49.27 AM.jpeg": 42599,
	"./WhatsApp Image 2022-10-13 at 4.49.30 AM.jpeg": 89695,
	"./WhatsApp Image 2022-10-13 at 4.49.34 AM (1).jpeg": 23894,
	"./WhatsApp Image 2022-10-13 at 4.49.36 AM (1).jpeg": 97201,
	"./WhatsApp Image 2022-10-13 at 4.56.11 AM.jpeg": 92697,
	"./WhatsApp Image 2022-10-13 at 4.56.27 AM.jpeg": 95751,
	"./WhatsApp Image 2022-10-13 at 5.20.09 AM.jpeg": 33825,
	"./infra_cover.jpg": 63098,
	"./leaderShip.png": 58699,
	"./newscover.jpg": 63326,
	"./studentCouncil.jpeg": 5417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12432;